// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.\\------packages-common-biz-components-src-parameters-parameters-module__container-YxzAnj {
  position: relative;
}

.\\------packages-common-biz-components-src-parameters-parameters-module__container-YxzAnj .\\------packages-common-biz-components-src-parameters-parameters-module__content-fd3sYk {
  overflow-x: auto;
}

.\\------packages-common-biz-components-src-parameters-parameters-module__container-YxzAnj .\\------packages-common-biz-components-src-parameters-parameters-module__content-fd3sYk.\\------packages-common-biz-components-src-parameters-parameters-module__readonly-mPwDoD {
  max-height: 300px;
  overflow: auto;
}

.\\------packages-common-biz-components-src-parameters-parameters-module__container-YxzAnj .\\------packages-common-biz-components-src-parameters-parameters-module__content-fd3sYk .\\------packages-common-biz-components-src-parameters-parameters-module__add-hot-area-em8Ayl {
  cursor: pointer;
  height: 16px;
}

.\\------packages-common-biz-components-src-parameters-parameters-module__container-YxzAnj .\\------packages-common-biz-components-src-parameters-parameters-module__content-fd3sYk .semi-tree-option-list {
  overflow: initial;
}

.\\------packages-common-biz-components-src-parameters-parameters-module__container-YxzAnj .\\------packages-common-biz-components-src-parameters-parameters-module__content-fd3sYk .semi-tree-option-list > div:first-child {
  margin-top: 0;
}

.\\------packages-common-biz-components-src-parameters-parameters-module__container-YxzAnj .semi-tree-option-list {
  overflow: inherit;
}

.\\------packages-common-biz-components-src-parameters-parameters-module__container-YxzAnj .semi-tree-option-list .semi-tree-option {
  padding-left: 0;
}

.\\------packages-common-biz-components-src-parameters-parameters-module__container-YxzAnj .semi-tree-option-list-block .semi-tree-option {
  cursor: default;
}

.\\------packages-common-biz-components-src-parameters-parameters-module__container-YxzAnj .semi-tree-option-list-block .semi-tree-option:hover {
  background: none;
}

.\\------packages-common-biz-components-src-parameters-parameters-module__container-YxzAnj .semi-tree-option-list-block .semi-tree-option:active {
  background: none;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `------packages-common-biz-components-src-parameters-parameters-module__container-YxzAnj`,
	"content": `------packages-common-biz-components-src-parameters-parameters-module__content-fd3sYk`,
	"readonly": `------packages-common-biz-components-src-parameters-parameters-module__readonly-mPwDoD`,
	"add-hot-area": `------packages-common-biz-components-src-parameters-parameters-module__add-hot-area-em8Ayl`,
	"addHotArea": `------packages-common-biz-components-src-parameters-parameters-module__add-hot-area-em8Ayl`
};
export default ___CSS_LOADER_EXPORT___;
